var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pageV2"},[_c('el-pagination',{attrs:{"background":"","current-page":_vm.page,"page-size":_vm.size,"total":_vm.total,"layout":_vm.layout},on:{"size-change":_vm.changeSize,"current-change":_vm.changePage}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5aeedf60","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/common/PaginationView.vue
// module id = null
// module chunks = 